module.exports = __webpack_public_path__ + "static/media/balance_500000_1000000.8e360bc1.png";